import { render, staticRenderFns } from "./Attendee.vue?vue&type=template&id=b7860ae4&scoped=true"
import script from "./Attendee.vue?vue&type=script&lang=js"
export * from "./Attendee.vue?vue&type=script&lang=js"
import style0 from "./Attendee.vue?vue&type=style&index=0&id=b7860ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7860ae4",
  null
  
)

export default component.exports